import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SignupService} from "../../../../merchant/services/signup.service";
import {Router} from "@angular/router";
import {validatePassword} from "../../../../common/utilities/CustomValidator";
import {CustomerSignupService} from "../../../services/customer-signup-service";
import {Country} from "../../../../common/components/input/interfaces/Country";

@Component({
  selector: 'app-customer-basic-info',
  templateUrl: './customer-basic-info.component.html',
  styleUrls: ['./customer-basic-info.component.scss']
})
export class CustomerBasicInfoComponent implements OnInit {

  public showPasswordFieldText = false;
  public signUpForm: FormGroup
  mobile = $localize`:@@contactUsMobileNumber:Mobile Number`
  code = $localize`:@@code:Code`
  countries: Country[] = [{
    nameEn: "Egypt",
    nameAr: "مصر",
    countryCode: "20",
    iso2letter: "EG",
    iso3letter: "EGY",
    createdAt: ""
  }]

  // showNameError: boolean = false;
  // showBusinessNameError: boolean = false;
  // showEmailError: boolean = false;
  // showPasswordError: boolean = false;

  serverError: string|null = null



  constructor(
    private formBuilder: FormBuilder,
    public customerSignupService: CustomerSignupService,
    private router: Router
  ) {  }
  ngOnInit() {
    this.customerSignupService.currentStepBs.next(this.customerSignupService.Step.BASIC_INFO);
    this.customerSignupService.disableBackButton = false
    this.customerSignupService.disableNextButton = false

    this.signUpForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.maxLength(256)]],
      // businessName: ['', [Validators.required, Validators.maxLength(256)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(320)]],
      password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(64), validatePassword]],
      agreeToTerms: [false, [Validators.requiredTrue]]
    });
    this.customerSignupService.signUpForm = this.signUpForm
  }

  get name() { return this.signUpForm.get('name'); }
  // get businessName() { return this.signUpForm.get('businessName'); }
  get email() { return this.signUpForm.get('email'); }
  get password() { return this.signUpForm.get('password'); }
  get agreeToTerms() { return this.signUpForm.get('agreeToTerms'); }

  togglePasswordShowButtonClicked () {
    this.showPasswordFieldText = !this.showPasswordFieldText;
  }

  signUpFormSubmitted() {
    // this.signUpForm
    this.router.navigate(["/email-confirmation"]).then()
  }

  protected readonly Validators = Validators;
}
